export default "__VITE_ASSET__e5bcfec2__"